import { Suspense, lazy, useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";
import moment from "moment";
import "moment/locale/pt-br";
import { useSelector } from "react-redux";
import { isset } from "../../utils/Utils";
import { useSnackbar } from "notistack";

moment.locale("pt-br");

const InicioPage = lazy(() => import("./inicio/InicioPage"));
const GeradorImagemPage = lazy(() => import("./gerador-imagem/GeradorImagemPage"));
const ExpertsPage = lazy(() => import("./experts/ExpertsPage"));
const GeradorVozPage = lazy(() => import("./gerador-voz/GeradorVozPage"));
const GeradorVideoPage = lazy(() => import("./gerador-video/GeradorVideoPage"));
const AgentesPage = lazy(() => import("./agentes/AgentesPage"));
const ViralShortPage = lazy(() => import("./viral-short/ViralShortPage"));
const ViralCutPage = lazy(() => import("./viral-cut/ViralCutPage"));
const PerfilPage = lazy(() => import("./perfil/PerfilPage"));
const UsuariosPage = lazy(() => import("./usuarios/UsuariosPage"));
const FinanceiroPage = lazy(() => import("./financeiro/FinanceiroPage"));

export default function HomePage() {
    const {
        user: { empresa, usr_is_admin: isAdmin },
    } = useSelector((state) => state.auth);
    const { pathname } = useLocation();
    const { closeSnackbar } = useSnackbar();

    const funcionalidades = empresa?.emp_funcionalidades;

    useEffect(() => {
        closeSnackbar();
    }, [pathname]);

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {<Redirect exact from="/" to="/inicio" />}

                <Route path="/inicio" component={InicioPage} />

                {!isset(funcionalidades?.Agentes) || funcionalidades.Agentes ? <Route path="/agentes" component={AgentesPage} /> : null}
                {!isset(funcionalidades?.GeradorImagem) || funcionalidades.GeradorImagem ? <Route path="/gerador-de-imagem" component={GeradorImagemPage} /> : null}
                {!isset(funcionalidades?.Experts) || funcionalidades.Experts ? <Route path="/experts" component={ExpertsPage} /> : null}
                {!isset(funcionalidades?.GeradorVoz) || funcionalidades.GeradorVoz ? <Route path="/gerador-de-voz" component={GeradorVozPage} /> : null}
                {!isset(funcionalidades?.GeradorVideo) || funcionalidades.GeradorVideo ? <Route path="/gerador-de-video" component={GeradorVideoPage} /> : null}
                {!isset(funcionalidades?.ViralShort) || funcionalidades.ViralShort ? <Route path="/viral-short" component={ViralShortPage} /> : null}
                {!isset(funcionalidades?.ViralCut) || funcionalidades.ViralCut ? <Route path="/viral-cut" component={ViralCutPage} /> : null}

                <Route path="/perfil" component={PerfilPage} />

                {isAdmin ? <Route path="/usuarios" component={UsuariosPage} /> : null}
                {isAdmin ? <Route path="/financeiro" component={FinanceiroPage} /> : null}

                <Redirect from="/esqueceu-senha" to="/" />
                <Redirect from="/esqueceu-senha-codigo" to="/" />
                <Redirect from="/alterar-senha" to="/" />
                <Redirect from="/signin" to="/" />
                <Redirect from="/auth/login" to="/" />
                <Redirect from="/login" to="/" />

                <Redirect to="/inicio" />
            </Switch>
        </Suspense>
    );
}
